import { render, staticRenderFns } from "./nowTimeStatus.vue?vue&type=template&id=3a9b0bd5&scoped=true&"
import script from "./nowTimeStatus.vue?vue&type=script&lang=js&"
export * from "./nowTimeStatus.vue?vue&type=script&lang=js&"
import style0 from "./nowTimeStatus.vue?vue&type=style&index=0&id=3a9b0bd5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a9b0bd5",
  null
  
)

export default component.exports